module.exports = __webpack_public_path__ + "r-v3/img/info_success.c73bfb79.svg";